import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    permission:sessionStorage.getItem('PERMISSION')||false,
  },
  getters: {
  },
  mutations: {
    setPermission(state) {
      state.permission = !state.loading;
    },
  },
  actions: {
    getPermission(context, data) {
      context.commit('setPermission', data); //调用方式 store.dispatch('push')
    },
  },
  modules: {
  }
})
